export default __webpack_public_path__ + "static/media/icon_cat_StackableBands.64aff46d.png";